import { useQuery } from "@tanstack/react-query";
import { pricingRepository } from "@/repositories/pricingRepository";

export const pricingKeys = {
  all: ["pricing"],
  plans: () => [...pricingKeys.all, "plans"],
  plan: (id) => [...pricingKeys.all, "plan", id],
};

export function usePricingPlans() {
  return useQuery({
    queryKey: pricingKeys.plans(),
    queryFn: () => pricingRepository.getPlans(),
  });
}
